import { FIELD_CONTROL_CLASS } from '@/styles/fieldControl';

export const FILTER_CONTROL_CLASS = `${FIELD_CONTROL_CLASS} group-data-filled/filter-field:border-primary/45`;

export const HIDDEN_UNTIL_FILTER_FIELD_ACTIVE_CLASS =
  'opacity-0 transition-opacity duration-200 group-focus-within/filter-field:opacity-100 group-has-[[aria-expanded=true]]/filter-field:opacity-100';
